import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { getLocale } from '@exo/frontend-common-utils';
import { useSessionContext } from '../session-context';
import { useLocales } from './useLocales';
import { mapTranslationData } from './translations.helper';

// queryVariables is gettiing passed to useLoacales query which is of the sig {source: 'fastlane'}
// just to ensure that adapter can connect to contentful even when the user is not autheticated
// if this is being used for any query post authetication then no need to pass any additional variables
export function useTranslations(translationsId, queryVariables) {
  const userConfig = useSessionContext();
  const {
    data: supportedLocales,
    loading: localeLoading,
    error: localeError
  } = useLocales(queryVariables);

  const locale = getLocale(
    userConfig?.localeInfo,
    supportedLocales?.locales,
    localeLoading,
    localeError
  );

  const { loading, error, data } = useQuery(
    gql`
      query TranslationCollection($locale: String, $translationsId: String) {
        translationCollection(where: { title: $translationsId }) {
          items {
            title
            childrenCollection {
              items {
                key
                value(locale: $locale)
              }
            }
          }
        }
      }
    `,
    {
      variables: { locale, translationsId },
      context: { isContentRequest: true },
      fetchPolicy: 'no-cache',
      skip: localeLoading
    }
  );

  const translations = mapTranslationData(data, translationsId);

  return { loading, error, data, messages: translations };
}

export default useTranslations;
